import React from 'react';
import { Fab } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { generateWhatsAppLink } from '../../driver-components/driver-order-lookup/utils';

interface PublicPageWrapperProps {
  children: React.ReactNode;
}

const PublicPageWrapper: React.FC<PublicPageWrapperProps> = ({ children }) => {
  return (
    <>
      {children}
      <Fab
        color="primary"
        size="large"
        aria-label="add"
        style={{
          position: 'fixed',
          zIndex: 9999999,
          bottom: 7,
          right: 7,
        }}
        onClick={() => window.open(generateWhatsAppLink('+33753560667'))}
      >
        <ContactSupportIcon />
      </Fab>
    </>
  );
};

export default PublicPageWrapper;

